module.exports = __webpack_public_path__ + "img/transaction.a9d62088.svg";